import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ReclamationCategoriesDataGrid } from "src/components/views/erp/reclamation/masterData/ReclamationCategoriesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/reclamations/reclamationCategory")({
	staticData: { title: i18n.t("reclamation_categories"), legacyViewKey: "reclamationCategoriesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ReclamationCategoriesDataGrid />;
}
